import axios from "axios";

export const getSignToolConfig = axios.get("/config/signTool.json")